
export class PopupLinkedIn {

  private popUpContainer: null | Element = null;
  private appearTime: string = '';
  private closeButton: null | Element = null;
  constructor(popUpContainer: Element) {
    this.popUpContainer = popUpContainer;
    this.appearTime = popUpContainer.querySelector('[data-appear-time]').getAttribute('data-appear-time');
    this.closeButton = popUpContainer.querySelector('[data-popup-close]')
    this.init()
  }

  init() {
    if (document.cookie.indexOf('linkedin-popup-closed=1') !== -1) return;
    this.showUp()
    this.addEventListener()
  }

  close() {
      this.popUpContainer.classList.add('hide-popup');
    this.popUpContainer.classList.remove('show-popup');
      document.cookie = 'linkedin-popup-closed=1; path=/; SameSite=Lax';
  }

  showUp() {
    const delay = parseInt(this.appearTime) * 1000;
    setTimeout(() => {
      this.popUpContainer.classList.remove('hide-popup');
      this.popUpContainer.classList.add('show-popup');
    }, delay);
  }

  addEventListener(){
    this.closeButton.addEventListener('click', () => {
        this.close()
    });
  }

}

document.querySelectorAll('[data-popup-container]').forEach((item) => {
  new PopupLinkedIn(item);
});
